import script from "./OnboardingAiBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiBadge.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiBadge.vue?vue&type=style&index=0&id=50bb5ab8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bb5ab8"]])

export default __exports__